"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("../styles/ShareDialogStyle");
var widgets_1 = require("@tableau/widgets");
var ClearButton_1 = require("./ClearButton");
var DataRoleIcon_1 = require("../img/DataRoleIcon");
var DatasourceIcon_1 = require("../img/DatasourceIcon");
var EmbedCodeLink_1 = require("./EmbedCodeLink");
var FlowIcon_1 = require("../img/FlowIcon");
var TelemetryService_1 = require("../utils/TelemetryService");
var Localize_1 = require("../../gen-src/Localize");
var MetricIcon_1 = require("../img/MetricIcon");
var Notes_1 = require("./Notes");
var Notification_1 = require("../utils/Notification");
var ProjectIcon_1 = require("../img/ProjectIcon");
var ShareButton_1 = require("./ShareButton");
var ShareLink_1 = require("./ShareLink");
var UserPicker_1 = require("./UserPicker");
var VizIcon_1 = require("../img/VizIcon");
var WorkbookIcon_1 = require("../img/WorkbookIcon");
var CollectionIcon_1 = require("../img/CollectionIcon");
var AccessNoticeTestId = 'access-notice';
exports.AccessNoticeTestId = AccessNoticeTestId;
var ContentNameLabelTestId = 'content-name-label';
exports.ContentNameLabelTestId = ContentNameLabelTestId;
var ShareSpinnerTestId = 'share-spinner';
var ShareSpinnerLabelTestId = 'share-spinner-label';
exports.ShareSpinnerLabelTestId = ShareSpinnerLabelTestId;
var ShareContentTestId = 'share-content';
exports.ShareContentTestId = ShareContentTestId;
var UnknownContentType = /** @class */ (function (_super) {
    __extends(UnknownContentType, _super);
    function UnknownContentType(contentType) {
        var _this = _super.call(this, "Unknown contentType: '" + contentType + "'") || this;
        _this.name = UnknownContentType.name;
        return _this;
    }
    return UnknownContentType;
}(Error));
var ShareDialog = /** @class */ (function (_super) {
    __extends(ShareDialog, _super);
    function ShareDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Method to clear UserPicker, will be set when UserPicker mounts
        _this.clearUsers = undefined;
        // Initialize share dialog state
        _this.state = {
            users: [],
            userPickerText: '',
            notesHasFocus: false,
            notes: '',
        };
        _this.shareLinkURI = function () {
            return decodeURI(_this.props.encodedShareLink);
        };
        _this.shareContent = function () {
            return React.createElement("div", null,
                _this.props.isNamedSharingEnabled && _this.userPicker(),
                _this.contentBelowPicker());
        };
        _this.usersChangedHandler = function (users) {
            _this.setState({ users: users });
        };
        _this.textChangedHandler = function (text) {
            _this.setState({ userPickerText: text });
        };
        _this.onNotesFocusChange = function (hasFocus) {
            _this.setState({ notesHasFocus: hasFocus });
        };
        _this.onNotesChange = function (e) {
            _this.setState({ notes: e.target.value });
        };
        // Public - only for testing purpose
        _this.onClearButtonClick = function () {
            TelemetryService_1.TelemetryService.Instance.log(TelemetryService_1.ShareDialogUserActionOptions.ContentCleared);
            // Clear UserPicker and Notes
            if (_this.clearUsers) {
                _this.clearUsers();
            }
            _this.setState({ notes: '' });
        };
        _this.mapContentTypeToString = function () {
            switch (_this.props.contentType.toLowerCase()) {
                case 'view':
                case 'recommendedview':
                case 'customizedview':
                    return Localize_1.Messages.view();
                case 'project':
                    return Localize_1.Messages.project();
                case 'workbook':
                    return Localize_1.Messages.workbook();
                case 'datasource':
                    return Localize_1.Messages.datasource();
                case 'flow':
                    return Localize_1.Messages.flow();
                case 'datarole':
                    return Localize_1.Messages.dataRole();
                case 'metric':
                    return Localize_1.Messages.metric();
                case 'publishedconnection':
                    return Localize_1.Messages.publishedConnection();
                case 'collection':
                    return Localize_1.Messages.collection();
                default:
                    throw new UnknownContentType(_this.props.contentType);
            }
        };
        _this.sharingAccessNotice = function () {
            switch (_this.props.contentType.toLowerCase()) {
                case 'collection':
                    return Localize_1.Messages.sharingAccessNoticeCollection();
                default:
                    return Localize_1.Messages.sharingAccessNotice({ CONTENT_TYPE: _this.mapContentTypeToString() });
            }
        };
        _this.contentTypeIconAltText = function () {
            return Localize_1.Messages.contentTypeIconAltText({ CONTENT_TYPE: _this.mapContentTypeToString() });
        };
        _this.contentName = function (maxLength) {
            if (maxLength === void 0) { maxLength = 100; }
            var HORIZONTAL_ELLIPSIS = '\u2026';
            return _this.props.contentName && _this.props.contentName.length > maxLength
                ? _this.props.contentName.substr(0, maxLength) + HORIZONTAL_ELLIPSIS
                : _this.props.contentName;
        };
        return _this;
    }
    ShareDialog.prototype.componentDidMount = function () {
        // Initialize share dialog notification with the external module's toast handler
        if (this.props.toastHandler) {
            Notification_1.Notification.Instance.init(this.props.toastHandler);
        }
        // Initialize telemetry logger
        if (this.props.logEvent) {
            TelemetryService_1.TelemetryService.Instance.initLogEvent(this.props.logEvent);
        }
        // If the saveDirtyView action is passed, it means that view is dirty
        // call this action to save the view and dialog will be refreshed with updated urls
        if (this.props.saveDirtyView) {
            this.props.saveDirtyView();
        }
    };
    ShareDialog.prototype.render = function () {
        return (React.createElement("div", { style: styles.shareDialog },
            React.createElement("div", { style: styles.title },
                React.createElement("span", { style: styles.titleSpan },
                    this.shareIcon(),
                    React.createElement("span", { style: styles.contentName, "data-tb-test-id": ContentNameLabelTestId }, this.contentName()))),
            React.createElement("div", { style: styles.permissions },
                React.createElement("span", { "data-tb-test-id": AccessNoticeTestId }, this.sharingAccessNotice())),
            this.shareContent()));
    };
    ShareDialog.prototype.contentBelowPicker = function () {
        if (this.shouldShowNotes()) {
            return (React.createElement("div", null,
                this.notes(),
                React.createElement("div", { style: styles.footerButtonsContainer },
                    this.clearButton(),
                    this.shareButton())));
        }
        else {
            // encodedShareLink will be an empty string
            // while waiting for link to be generated
            if (this.props.encodedShareLink.length < 1) {
                return this.spinner();
            }
            else {
                return (React.createElement("div", { "data-tb-test-id": ShareContentTestId },
                    this.shareLink(),
                    this.props.embedCode && this.embedCode()));
            }
        }
    };
    ShareDialog.prototype.userPicker = function () {
        var _this = this;
        return React.createElement(UserPicker_1.UserPicker, { onUsersChanged: this.usersChangedHandler, onTextChanged: this.textChangedHandler, saveClearUsers: function (fnToCall) { return _this.clearUsers = fnToCall; } });
    };
    // Show the notes when Named Sharing is enabled AND
    // if there are recipients or text in the RecipientPicker,
    // or if there is text in the notes field,
    // or if the notes field is focused
    ShareDialog.prototype.shouldShowNotes = function () {
        return this.props.isNamedSharingEnabled && (this.state.users.length > 0 ||
            this.state.userPickerText.length > 0 ||
            this.state.notes.length > 0 ||
            this.state.notesHasFocus);
    };
    ShareDialog.prototype.notes = function () {
        return React.createElement(Notes_1.Notes, { currentLength: this.state.notes.length, onFocusChange: this.onNotesFocusChange, onNotesChange: this.onNotesChange });
    };
    ShareDialog.prototype.clearButton = function () {
        return React.createElement(ClearButton_1.ClearButton, { onClick: this.onClearButtonClick });
    };
    ShareDialog.prototype.shareButton = function () {
        return React.createElement(ShareButton_1.ShareButton, { onSuccessHandler: this.props.closeDialogHandler, contentId: this.props.contentId, contentName: this.props.contentName, contentType: this.props.contentType, isAllUsersValid: this.state.users.every(function (u) { return u.verified || false; }), userIds: this.state.users.map(function (u) { return u.id; }), url: this.shareLinkURI(), message: this.state.notes, shouldShareThumbnail: this.props.shouldShareThumbnail });
    };
    ShareDialog.prototype.spinner = function () {
        return (React.createElement("div", { style: styles.spinnerContainer },
            React.createElement(widgets_1.ActivitySpinnerWidget, { testId: ShareSpinnerTestId }),
            React.createElement("label", { "data-tb-test-id": ShareSpinnerLabelTestId, role: 'alert', style: styles.spinnerLabel }, Localize_1.Messages.loadingLink())));
    };
    ShareDialog.prototype.shareLink = function () {
        return React.createElement(ShareLink_1.ShareLink, { shareLink: this.shareLinkURI(), contentName: this.contentName(), isNamedSharingEnabled: this.props.isNamedSharingEnabled });
    };
    ShareDialog.prototype.embedCode = function () {
        return React.createElement(EmbedCodeLink_1.EmbedCodeLink, { embedCode: this.props.embedCode, contentName: this.contentName() });
    };
    ShareDialog.prototype.shareIcon = function () {
        // Non decorative icon need text alternative so it can be read by screen reader
        var iconProps = {
            style: styles.icon,
            'aria-label': this.contentTypeIconAltText(),
        };
        switch (this.props.contentType.toLowerCase()) {
            case 'view':
            case 'recommendedview':
            case 'customizedview':
                return React.createElement(VizIcon_1.VizIcon, __assign({}, iconProps));
            case 'project':
                return React.createElement(ProjectIcon_1.ProjectIcon, __assign({}, iconProps));
            case 'workbook':
                return React.createElement(WorkbookIcon_1.WorkbookIcon, __assign({}, iconProps));
            case 'datasource':
                return React.createElement(DatasourceIcon_1.DatasourceIcon, __assign({}, iconProps));
            case 'flow':
                return React.createElement(FlowIcon_1.FlowIcon, __assign({}, iconProps));
            case 'datarole':
                return React.createElement(DataRoleIcon_1.DataRoleIcon, __assign({}, iconProps));
            case 'metric':
                return React.createElement(MetricIcon_1.MetricIcon, __assign({}, iconProps));
            case 'publishedconnection':
                return React.createElement(DatasourceIcon_1.DatasourceIcon, __assign({}, iconProps));
            case 'collection':
                return React.createElement(CollectionIcon_1.CollectionIcon, __assign({}, iconProps));
            default:
                throw new UnknownContentType(this.props.contentType);
        }
    };
    return ShareDialog;
}(React.Component));
exports.ShareDialog = ShareDialog;
//# sourceMappingURL=ShareDialog.js.map